import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';

import { ModalComponent } from '../../../components/modal/modal.component';
import { GlobalCommsService } from '../../../services/global-comms/global-comms.service';

import { ServicesService } from '../../../services/services/services.service';
import { StandardReferralDetailsFormComponent } from '../../standard-referral-details/standard-referral-details-form/standard-referral-details-form.component';

@Component({
  selector: 'app-lw-will-review',
  templateUrl: './lw-will-review.component.html',
  styleUrls: ['./lw-will-review.component.scss']
})
export class LwWillReviewComponent implements OnInit, OnDestroy {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;

  loading: boolean;
  checkingStatus: boolean;

  private subscriptions: Subscription[];

  constructor(
    public modalRef: MDBModalRef,
    private modalService: MDBModalService,
    private globalCommsService: GlobalCommsService,
    private servicesService: ServicesService,
  ) {
    this.loading = false;
    this.subscriptions = [];
  }

  ngOnInit() {

    this.subscriptions.push( this.globalCommsService.currentRef.subscribe(
      resp => {
        if( resp === 'close' ) {
          this.modalRef.hide();
          this.getService();
        }
      }
    ));

  }

  ngOnDestroy() {
    for( let subscription of this.subscriptions ) {
      subscription.unsubscribe();
    }
  }

  openReferralForm() {

    let modalOptions = Object.assign(
      {
        ignoreBackdropClick: true,
        data: {
          heading: 'Referral Information',
          component: StandardReferralDetailsFormComponent,
          object: this.object,
        }
      },
      {
        class: 'modal-lg'
      }
    );

    this.openModal( modalOptions );

  }

  openModal( modalOptions: Object ): void {
    this.modalRef = this.modalService.show( ModalComponent , modalOptions );
  }

  canStartForm(): boolean {
    return ( [ 'not-started' , 'started' , 'skipped' ].indexOf( this.object['service_type_status'] ) !== -1 && ! this.loading );
  }

  canEditForm(): boolean {
    return ( [ 'not-started' , 'started' , 'ready' , 'skipped' ].indexOf( this.object['service_type_status'] ) !== -1 && ! this.loading );
  }

  isComplete(): boolean {
    return ( [ 'complete' ].indexOf( this.object['service_type_status'] ) !== -1 );
  }

  canSubmitForm(): boolean {
    return ( [ 'ready' ].indexOf( this.object['service_type_status'] ) !== -1 && ! this.loading );
  }

  getService() {
    this.subscriptions.push( this.servicesService.getService( this.object['id'] ).subscribe(
      resp => {
        this.object = resp;
      },
      error => {
        //console.log( error );
      }
    ));
  }

  submitWill(): void {

    this.loading = true;

    this.servicesService.submitWill( this.object['id'] ).subscribe(
      resp => {
        this.object = resp;
        this.loading = false;
        this.servicesService.patchService( resp );
      },
      error => {
        this.loading = false;
      },
    );

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
